var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegionSelectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1137 3.27378L9.40033 2.56045L5.70033 6.26045V6.98045H6.42033L10.1137 3.27378ZM8.66699 1.82712L9.52699 0.967116C9.61938 0.873589 9.72942 0.799333 9.85073 0.748652C9.97203 0.697972 10.1022 0.671875 10.2337 0.671875C10.3651 0.671875 10.4953 0.697972 10.6166 0.748652C10.7379 0.799333 10.8479 0.873589 10.9403 0.967116L11.707 1.73378C12.1003 2.12712 12.1003 2.76045 11.707 3.14712L11.2537 3.60045L11.2403 3.61378L10.8537 4.00045L6.85366 8.00045H4.66699V5.82712L8.66699 1.82712ZM7.14699 1.46045L6.78033 1.82712L5.93366 2.67378C3.73366 2.70712 2.00033 4.40712 2.00033 6.80712C2.00033 8.36712 3.30033 10.4338 6.00033 12.9004C8.70033 10.4338 10.0003 8.37378 10.0003 6.80712V6.74045L11.2003 5.54045C11.287 5.94045 11.3337 6.36712 11.3337 6.80712C11.3337 9.02045 9.55366 11.6404 6.00033 14.6738C2.44699 11.6404 0.666992 9.02045 0.666992 6.80712C0.666992 3.48712 3.20033 1.34045 6.00033 1.34045C6.38699 1.34045 6.77366 1.38045 7.14699 1.46045Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegionSelectionIcon);
export default __webpack_public_path__ + "static/media/RegionSelectionIcon.d0e1e8a40c946be0a87d0f756370e0b9.svg";
export { ForwardRef as ReactComponent };